<div>
	<div align="right" class="lecture-dialog-icon">
		<button mat-icon-button mat-dialog-close>
        	<mat-icon color="red">close</mat-icon>
      	</button>
	</div>
	<div class="scroller">
		<table mat-table [dataSource]="cabList">
			<ng-container matColumnDef="CAB">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let element">{{element.cabNum}}</td>
			</ng-container>
			<ng-container matColumnDef="detail">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let element">{{element.cabInconnu ? 'inconnu' : 'doublon'}}</td>
			</ng-container>		
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		</table>
	</div>
</div>
